import '../../style/empty.scss'
export function createEmpty() {
  return {
    functional: true,
    name: 'TableEmpty',
    render(h, context) {
      return (
        <div class="kye-table-v2-empty" style={{width: isFinite(context.props.width) ? (context.props.width + 'px') : context.props.width, height: context.props.height + 'px'}}>
          {/* <i class="kye-table-v2-empty-icon"></i> */}
          <span>{context.props.emptyText || '查询结果为空'}</span>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/empty/index.js